import React from "react"
import {DataInput, DragDropFile} from "./file-input";
import {valueOrEmpty} from "../../../../utils/number";
import {groupBy} from "../../../../utils/groupBy";
import {hasDefinedMembers} from "../../../../utils/hasDefinedMembers";



class BulkImportMeasurements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data || [],
            fileName:  props.fileName,
            errors: undefined
        };
    };

    componentWillReceiveProps(props) {
        this.setState({
            data: props.data || [],
            fileName: props.fileName
        })
    }

    onImportSuccess = (data, fileName) => {
        const errors = []
        let products = this.props.selectedProducts || []

        console.log("products", products)

        if (data.length !== products.length) {
            errors.push({sheet: '-', message: 'Number of sheets must match number of selected products'})
        }
        else {
            products  = groupBy(products, 'articleNumber')
            const sheets = groupBy(data.filter(d => d.articleNumber !== undefined), 'articleNumber')

            data.filter(d => d.articleNumber === undefined).forEach(d => {
                errors.push({sheet: d.name, message: `Does not contain an article number`})
            })

            //validate
            Object.keys(sheets).forEach(articleNumber => {
                const currentProducts = products[articleNumber] || []
                const currentSheets = sheets[articleNumber] || []

                if (currentProducts.length !== currentSheets.length) {
                    errors.push({sheet: '-', message: `Number of products with article number '${articleNumber}' does not match. Provided ${currentProducts.length}, but found ${currentSheets.length} in file.`})
                }
            })

            if (errors.length === 0) {
                Object.keys(sheets).forEach(articleNumber => {
                    const currentProducts = products[articleNumber] || []
                    const currentSheets = sheets[articleNumber] || []
                    currentSheets.sort((a, b) => a.index - b.index)

                    currentProducts.sort((a, b) => {
                        if(a.hasMeasurements === b.hasMeasurements) {
                            return a.number - b.number
                        }

                        return a.hasMeasurements - b.hasMeasurements
                    }).forEach((product, index) => {
                        const sheet = currentSheets[index]
                        product.new_measurements = sheet.rows.slice(1, sheet.rows.length).map(row => {
                            if(row.length === 0) {
                                return undefined
                            }

                            return {
                                characteristic: row[0],
                                values:  [...Array(10).keys()]
                                    .map(i => row[i+1] ? `${row[i+1].toString().toLowerCase().replace(/,/g, '.').replace(/nok/g, 'false').replace(/ok/g, 'true')}` : ''),
                            }
                        }).filter(m => typeof m !== 'undefined')

                        product.woodInfo = sheet.woodInfo && hasDefinedMembers(sheet.woodInfo) ? sheet.woodInfo : null

                        product.fileName = undefined
                    })
                })
            }
        }

        this.setState({
            errors,
            fileName
        })

        this.props.importSuccess(fileName)
    }

    clear = () => {
        this.props.clear()
        this.setState({
            data: [],
            fileName:  undefined,
            errors: undefined
        })
    }


    render() {
        const { t } = this.props
        return (
            <div className={"row"} >
                <div className={"col-3"} style={{display: "flex", alignItems: "center"}}>
                    <DataInput handleFile={this.handleFile} onImportSuccess={this.onImportSuccess} fileName={this.state.fileName} bulkImport={true} t={t}/>
                </div>
                <div className={"row "}>
                    <div className={"col-12 "}>
                        <button type="button" className="button" size="small" onClick={this.clear}>{t('general.clear')}
                        </button>
                    </div>
                </div>

                <div className={"col-9"}  style={{display: "flex", alignItems: "center"}}>
                    {
                        this.state.errors && this.state.errors.length > 0 ? <OutTable errors={this.state.errors} t={t}/> : this.state.errors ? <div style={{"color": "#6acb5f"}}>
                            <i className="far fa-check-circle"/> Measurements will be imported.
                        </div> : undefined
                    }
                </div>

            </div>
        )
    }
}


class OutTable extends React.Component {
    constructor(props) {
        super(props);
    };



    render() {
        const { t } = this.props
        console.log(this.props.errors)
        return (
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <td>{t('general.sheets')}</td>
                        <td>{t('general.error.error')}</td>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        this.props.errors.map((error, index) => {
                            return (
                                <tr key={index}>
                                    <td>{error.sheet}</td>
                                    <td>{error.message}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        );
    };
}

export default BulkImportMeasurements
